import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Sayfa Bileşenleri
import DiyetisyenDashboard from './DiyetisyenDashboard';
import DanisanListesi from './DanisanListesi';
import DanisanEkle from './DanisanEkle';
import DanisanDetay from './DanisanDetay';
import RandevuTakvimi from './RandevuTakvimi';
import RandevuDetay from './RandevuDetay';
import KutuphaneSayfasi from './KutuphaneSayfasi';
import BesinYonetimi from './BesinYonetimi';
import OlcuBirimiYonetimi from './OlcuBirimiYonetimi';
import KategoriYonetimi from './KategoriYonetimi';
import Sablonlarim from './Sablonlarim';
import Profil from './Profil';
import DestekSayfasi from './DestekSayfasi';
import TicketDetay from './TicketDetay';

function DiyetisyenRoutes({ theme, themePreset, onThemeChange }) {
  return (
    <Routes>
      <Route path="/" element={<DiyetisyenDashboard theme={theme} />} />
      <Route path="/danisanlar" element={<DanisanListesi theme={theme} />} />
      <Route path="/danisan/yeni" element={<DanisanEkle theme={theme} />} />
      <Route path="/danisan/:danisanId" element={<DanisanDetay theme={theme} />} />
      <Route path="/randevular" element={<RandevuTakvimi theme={theme} />} />
      <Route path="/randevu/:randevuId" element={<RandevuDetay theme={theme} />} />
      <Route path="/sablonlar" element={<Sablonlarim theme={theme} />} />
      <Route path="/profil" element={<Profil theme={theme} themePreset={themePreset} onThemeChange={onThemeChange} />} />
      <Route path="/destek" element={<DestekSayfasi theme={theme} />} />
      <Route path="/destek/ticket/:ticketId" element={<TicketDetay theme={theme} />} />

      <Route path="/kutuphane" element={<KutuphaneSayfasi theme={theme} />}>
        <Route index element={<Navigate to="/kutuphane/besinler" replace />} />
        <Route path="besinler" element={<BesinYonetimi theme={theme} />} />
        <Route path="olcu-birimleri" element={<OlcuBirimiYonetimi theme={theme} />} />
        <Route path="kategoriler" element={<KategoriYonetimi theme={theme} />} />
      </Route>
    </Routes>
  );
}
export default DiyetisyenRoutes;

